import * as React from 'react';

import styled from '@emotion/styled';

import { Typography } from '@coursera/cds-core';

import ReactPriceDisplay from 'bundles/ownable-products-common/components/ReactPriceDisplay';

type Props = {
  unitPrice: string;
  seats: number;
  amountTotal: string;
  currencyCode: string;
};

const Row = styled.div`
  width: 300px;
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const Label = styled.div`
  font-weight: bold;
`;

const Value = styled.div`
  /* stylelint-disable-line no-empty-source */
`;

const EnterpriseLeadSummary: React.FC<Props> = ({ unitPrice, seats, amountTotal, currencyCode = 'USD' }) => {
  const renderPrice = (price: string) => <ReactPriceDisplay value={parseFloat(price)} currency={currencyCode} />;
  return (
    <div>
      <Typography variant="h2">Purchase summary</Typography>

      {unitPrice ? (
        <div className="c-formSectionContent">
          <Row>
            <Label>Per user per year</Label>
            <Value>{renderPrice(unitPrice)}</Value>
          </Row>

          <Row>
            <Label>Number of users</Label>
            <Value>{seats}</Value>
          </Row>

          <Row>
            <Label>Total</Label>
            <Value>{renderPrice(amountTotal)}</Value>
          </Row>

          <Row>
            <Label>Bill annually</Label>
            <Value>x1</Value>
          </Row>

          <Row>
            <Label>Invoice total</Label>
            <Value>{renderPrice(amountTotal)}</Value>
          </Row>
        </div>
      ) : (
        <div className="c-formSectionContent">Number of seats or country is not correct, please check the form</div>
      )}
    </div>
  );
};

EnterpriseLeadSummary.displayName = 'EnterpriseLeadSummary';

export default EnterpriseLeadSummary;
